import { Stack, Typography, Link } from "@mui/material"
import { FormContainer, NavButtons } from "../../../../Menu/Flow"
import { ListContainer } from "../../../../../../legacyComponents/componentsV2/Flow"
import { Styles } from "../../../../../../legacyComponents/config"
import employerFlowStyles from "../../styles"

export default function AllowanceACA(props) {
    const { mode, exitUrl, step } = props

    return (
        <Stack spacing="30px" height="100%">
            <FormContainer>
                <Typography variant="h2" sx={employerFlowStyles.h2}>ACA Affordability</Typography>

                <Stack spacing={2} sx={{ marginTop: "20px" }}>
                    <Typography sx={{ fontWeight: "bold" }}>
                        How we calculate an ACA-affordable allowance
                    </Typography>

                    <Typography>
                        When you choose to set an ACA-affordable allowance, Salusion calculates affordability using IRS-approved safe harbors in a way that is compliant and fully automated.
                    </Typography>

                    <Typography>
                        For each employee, we:
                    </Typography>

                    <Typography sx={{ fontWeight: "bold" }}>
                        1. Start with the lowest-cost Silver plan (LCSP)
                    </Typography>

                    <Typography>
                        We identify the lowest-cost Silver plan available to the employee based on:
                    </Typography>

                    <ListContainer sx={{ marginTop: "0px" }}>
                        <Typography component="li">The employee's site of employment, and</Typography>
                        <Typography component="li">The employee's age</Typography>
                    </ListContainer>

                    <Typography>
                        Using the site of employment is a permitted safe harbor and allows affordability to be applied consistently while aligning with allowed geographic employee classes.
                    </Typography>

                    <Typography sx={{ fontWeight: "bold" }}>
                        2. Apply the ACA affordability standard
                    </Typography>

                    <Typography>
                        We then limit the employee's required contribution using the ACA affordability threshold (expressed as a percentage of income, as set annually).
                    </Typography>

                    <Typography sx={{ fontWeight: "bold" }}>
                        3. Use the federal poverty level (FPL) income safe harbor
                    </Typography>

                    <Typography>
                        Rather than relying on actual wage data, we use the federal poverty level income safe harbor. This approach is permitted under ACA rules and allows affordability to be calculated uniformly and automatically across employees.
                    </Typography>

                    <Typography>
                        This method is designed to produce a low-cost allowance while remaining simple to administer. While it may not result in the absolute lowest possible allowance in every individual case, it is the lowest allowance that can be calculated consistently, compliantly, and without ongoing manual administration.
                    </Typography>

                    <Typography>
                        The result is an allowance structure that is compliant, defensible, and easy to manage at scale.
                    </Typography>

                    <ListContainer sx={{ marginTop: "10px" }}>
                        <Typography component="li">
                            <Link
                                href="https://my.salusion.com/calculator/affordable-ichra-employer"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ 
                                    color: Styles.Color.tertiary,
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }}
                            >
                                You can preview allowance amounts using your employee data →
                            </Link>
                        </Typography>
                    </ListContainer>
                </Stack>
            </FormContainer>

            <NavButtons mode={mode} enableSave={true} exitUrl={exitUrl} step={step} />
        </Stack>
    )
}
